import React from "react";

const NailCustomer = () => {
  return (
    <div className="gelNailArtTestimonialContainer">
      <h5>Customer Testimonials</h5>
      <p>
        Our clients love the nails color change services at SCENT. Here are some
        of their testimonials:
      </p>
      <div className="gelNailArtTestimonialContent" id="gelNailArtTestimonialContent">
        <p>
          <span className="quote">"</span> I had an amazing experience at SCENT.
          The nails color change service was top-notch, and my nails look
          fabulous. The technicians are skilled and very professional. I will
          definitely be coming back! <span className="quote">"</span> -{" "}
          <span>Riya M. </span>
        </p>
        <p>
          <span className="quote">"</span> SCENT is my go-to place for nails
          color change in Bangalore. They have an extensive color range, and the
          quality of service is exceptional. Highly recommend!{" "}
          <span className="quote">"</span> - <span>Ananya K. </span>
        </p>
        <p>
          <span className="quote">"</span> I had an amazing experience at SCENT.
          The nails color change service was top-notch, and my nails look
          fabulous. The technicians are skilled and very professional. I will
          definitely be coming back! <span className="quote">"</span> -{" "}
          <span>Priya S. </span>
        </p>
      </div>
      <p>
        <a href="https://scentlifestyle.com/service"> Nails color change in Bangalore</a> is more than just a
        beauty service; it’s an expression of style and personality. At SCENT,
        we pride ourselves on providing the best{" "}
        <a href="https://scentlifestyle.com/service">nails color change</a> experience in the city. With our
        extensive color palette, high-quality products, expert technicians, and
        commitment to hygiene, you can trust us to deliver outstanding results
        every time. Whether you’re looking to try the latest trends or stick to
        classic shades, SCENT is the ultimate destination for nails color change
        in Bangalore.
      </p>
      <p>
        Visit us today and discover the difference that professional nails color
        change can make. Book your appointment now and let SCENT help you
        achieve the perfect nails you’ve always wanted. Remember,{" "}
        <a href="https://scentlifestyle.com/service">nails color change in Bangalore</a> has never been this
        fabulous!
      </p>
    </div>
  );
};

export default NailCustomer;
